/**
 * On-chain read surface used to enrich the API listing with the fields
 * the Aave GraphQL `Vault` type omits: the share `decimals`,
 * `totalSupply()`, and `convertToAssets(uint256)` (the share price).
 */

/** Standard ERC-20 `decimals()` + `totalSupply()`. */
export const Erc20MetaAbi = [
  {
    name: 'decimals',
    type: 'function',
    stateMutability: 'view',
    inputs: [],
    outputs: [{ type: 'uint8' }],
  },
  {
    name: 'totalSupply',
    type: 'function',
    stateMutability: 'view',
    inputs: [],
    outputs: [{ type: 'uint256' }],
  },
] as const

/** ERC-4626 `convertToAssets(uint256)` — 1 share → X underlying. */
export const Erc4626ConvertAbi = [
  {
    name: 'convertToAssets',
    type: 'function',
    stateMutability: 'view',
    inputs: [{ type: 'uint256', name: 'shares' }],
    outputs: [{ type: 'uint256', name: 'assets' }],
  },
] as const

/**
 * ERC-4626 `totalAssets()` — the vault's assets under management in raw
 * underlying units, the canonical TVL. Aave Earn vaults supply into Aave and
 * hold aTokens, so the underlying-token `balanceOf` (and the API's `balance`
 * field) reads ~0; `totalAssets()` is the only correct TVL source.
 */
export const Erc4626TotalAssetsAbi = [
  {
    name: 'totalAssets',
    type: 'function',
    stateMutability: 'view',
    inputs: [],
    outputs: [{ type: 'uint256' }],
  },
] as const
